import dayjs, { Dayjs } from "dayjs"
import utc from "dayjs/plugin/utc"
dayjs.extend(utc)

export type DateType = Dayjs;

export const dateToString = (date: DateType): string => date.toISOString();

export const getTodaysDate = (): DateType => dayjs().startOf('day');

export const stringToDate = (stringDate: string): Date => dayjs(stringDate).toDate();

export const transformStringDate = (date: string, currentFormat: string, newFormat: string) => dayjs(date, currentFormat).format(newFormat)

export const formatDate = (date: Date | string, newFormat: string) => dayjs(date).format(newFormat)

export const formatToDate = (date: Date) => dayjs(date)